module.exports = __webpack_public_path__ + "static/media/google-login-icon-png.80316c1c.png";